import { get } from 'lodash';
import { useMemo } from 'react';
import { useNotifications } from './useNotifications';
import { isChatNotification } from '../../filters/notifications/isChatNotification';

export function useChatNotifications({ chatSessionId, filter }) {
    const notifications = useNotifications();
    return useMemo(() => {
        let result = notifications.filter(isChatNotification);
        if (chatSessionId) {
            result = result.filter(n => n.content.data.chatId == chatSessionId);
        }
        if (filter) {
            result = result.filter(filter);
        }
        return result;
    }, [filter, chatSessionId])
}


